import comp from "./DropzoneComponent";
export default comp;
